import React, { ReactNode } from "react";

import { CartStyles } from "Pages/ClientBudgetService/style";
import { Box } from "styles/globalComponents";
import HomeIcon from "Assets/Images/home-icon.png";
import CartItem from "Components/ServiceForm/CartItem";
import { createToast } from "Utils/toastFunc";
import { useParams } from "react-router";
import { CartItem as ICartItem } from "Dtos/IBudget";
import {
  listProductsOnBudgetsCart,
  registerProductOnBudgetCart,
} from "Requests/Partners/Budgets";
import { CartDetailValue } from "Pages/ServiceForm/components/Cart/CartDetailValue";
import { formatBRLCurrency } from "Utils/FormatCurrency";
import { useQuery, useQueryClient } from "react-query";
import { BUDGETSTATUS } from "Constants/Budget";
import { Loader } from "Components/Loader";

interface CartDetailsProps {
  children: ReactNode;
}

export default function CartDetails({ children }: CartDetailsProps) {
  const { id } = useParams<{ id: string }>();

  const { data, isFetching } = useQuery({
    queryFn: () => listProductsOnBudgetsCart(Number(id)),
    queryKey: ["budget-cart-items-units", id],
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
  const client = useQueryClient();

  const updateQueryCache = (oldData: undefined | any, newData: any) => {
    if (oldData) return newData;
  };

  const handleProductQuantity = async (
    operation: string,
    quantity: number,
    product: ICartItem
  ) => {
    const productQuantity =
      operation === "add" ? product.amount + 1 : product.amount - 1;

    if (data?.patient?.id) {
      const payload = {
        budget_id: Number(id),
        patient_id: data?.patient?.id,
        item: {
          amount: productQuantity,
          product_id: product.product_id,
        },
      };
      const response = await registerProductOnBudgetCart(payload);

      client.setQueryData(["budget-cart-items-units", id], (oldData: any) =>
        updateQueryCache(oldData, response)
      );

      createToast("success", "Quantidade atualizada com sucesso!");
    }
  };

  const itemsWord = data?.cart?.length === 1 ? "item" : "itens";

  const blockedActions = data?.status?.id === BUDGETSTATUS.converted;

  return (
    <CartStyles>
      <div className="cart-details-container">
        <div className="cart-details-container-content">
          <h5 className="title-cart text-left purpletext text-separate-text">
            Resumo:{" "}
            <b>
              {" "}
              {data?.cart?.length} {itemsWord} no orçamento
            </b>
          </h5>

          <section className="budget-collect-type">
            <Box display="flex" gap="10" align="center">
              <img src={HomeIcon} alt="" />
              <p className="collect-title">
                <strong>ATENDIMENTO DOMICILIAR</strong> <br />
              </p>
            </Box>
          </section>

          <div
            className={`cart-itens-holder new-layout-cart-itens-holder ${
              blockedActions ? "blocked" : ""
            }`}
          >
            {data?.cart.map((item) => (
              // @ts-ignore
              <CartItem
                key={item?.product_id}
                product={item}
                isProduct
                amountAction={handleProductQuantity}
                debounceDep={data?.cart}
                newLayout
              />
            ))}
          </div>

          <CartDetailValue
            label="Total"
            value={formatBRLCurrency(data?.total, true)}
          />

          {data?.unit?.id && (
            <div className="unit-selected">
              {isFetching ? (
                <Box display="flex" justify="center" pb="20">
                  <Loader size={10} />
                </Box>
              ) : (
                <>
                  <p className="unit">Unidade selecionada</p>
                  <p className="unit-name">{data?.unit?.name}</p>
                </>
              )}
            </div>
          )}

          {children}
        </div>
      </div>
    </CartStyles>
  );
}
